// http全局拦截和定义
import Fly from 'flyio/dist/npm/fly'
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import util from '@/libs/util'
import Setting from '@/setting'
import _ from 'lodash'

import {Toast, Notify} from 'vant'

const vm = new Vue()

// 创建一个错误
function errorCreate(msg) {
  const err = new Error(msg)
  errorLog(err)
  throw err
}

// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch('admin/log/push', {
    message: '数据请求异常',
    type: 'error',
    meta: {
      error: err
    }
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.error('>>>>>> Error >>>>>>')
    // console.log(err)
  }
  // 显示提示，可配置使用 iView 的 Toast 还是 Notify 组件来显示
  if (Setting.errorModalType === 'Toast') {
    Toast({
      message: err.message,
      duration: Setting.modalDuration
    })
  } else if (Setting.errorModalType === 'Notify') {
    Notify({
      type: 'danger',
      message: err.message,
      duration: Setting.modalDuration
    })
  }
}

const fly = new Fly()

// 请求拦截器
fly.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = JSON.parse(localStorage.getItem('token'))
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers.Authentication = token
    // config.headers.ThirdPartyId = util.cookies.get('third-party-id')
    config.headers.ThirdPartyId = 1
    return config
  },
  error => {
    // 发送失败
    // console.log(error)
    Promise.reject(error)
  }
)

// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  (response) => {
    const dataResponse = response.data
    // 这个状态码是和后端约定的
    const {code} = dataResponse
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口
      return dataResponse
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 0:
          // [ 示例 ] code === 0 代表没有错误
          return dataResponse.data
        case 'xxx':
          // [ 示例 ] 其它和后台约定的 code
          errorCreate(`[ code: xxx ] ${dataResponse.msg}: ${response.config.url}`)
          break
        default:
          // 不是正确的 code
          errorCreate(`${dataResponse.msg}: ${response.config.url}`)
          break
      }
    }
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break
        case 401:
          error.message = '未授权，请登录';
          router.push({name: 'login'});
          break
        case 403:
          error.message = '拒绝访问';
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break
        case 408:
          error.message = '请求超时';
          break
        case 500:
          error.message = `${error.response.data.message}`;
          break
        case 501:
          error.message = '服务未实现';
          break
        case 502:
          error.message = '网关错误';
          break
        case 503:
          error.message = '服务不可用';
          break
        case 504:
          error.message = '网关超时';
          break
        case 505:
          error.message = 'HTTP版本不受支持';
          break
        default:
          break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

Vue.prototype.$http = fly

const request = {
  post(url, params, header) {
    return vm.$http.post(Setting.apiBaseURL + url, params, {
      transformRequest: [(params) => {
        if (header && header.contentType) {
          return params
        }
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': (header && header.contentType) || 'application/x-www-form-urlencoded'
      }
    })
  },
  get(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }

    return vm.$http.get(`${Setting.apiBaseURL}${url}${_params}`)
  },
  put(url, params, header) {
    params = _.omitBy(params, function (val) {
      return !val
    })
    return vm.$http.put(Setting.apiBaseURL + url, params, {
      transformRequest: [(params) => {
        if (header && header.contentType) {
          return params
        }
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': (header && header.contentType) || 'application/x-www-form-urlencoded'
      }
    })
  },
  delete(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return vm.$http.delete(`${Setting.apiBaseURL}${url}${_params}`)
  },
  export(url, params = {}) {
    // Message.loading('导出数据中')
    return vm.$http.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      const fileName = `${new Date().getTime()}_导出结果.xlsx`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      // console.error(r)
      // Message.error('导出失败')
    })
  },
  download(url, params, filename) {
    // Message.loading('文件传输中')
    return vm.$http.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      // console.error(r)
      // Message.error('下载失败')
    })
  },
  upload(url, params) {
    return vm.$http.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  uploadSignFile(file, params = {}) {
    const formData = new FormData()
    const config = {headers: {'Content-Type': 'multipart/form-data'}}
    _.each(params, (v, k) => formData.append(k, v))
    return new Promise((resolve, reject) => {
      let url
      if (_.isArray(file)) {
        file.forEach(f => formData.append('files', f))
        url = 'multi-upload'
      } else {
        formData.append('file', file)
        url = 'upload'
      }
      vm.$http.post(Setting.apiBaseURL + url, formData, config).then(resolve).catch(reject)
    })
  },
  multiUpload(files, businessModule) {
    const params = new FormData()
    files.forEach(f => params.append('files', f))
    if (businessModule) params.append('businessModule', businessModule)
    return new Promise((r, j) => {
      this.upload(Setting.apiBaseURL + 'multi-upload', params).then(r).catch(err => {
        Toast.fail('文件上传失败')
        j(err)
      });
    })
  },

  multiUploadAddWaterMarking(files, businessModule, address, longitudeAndLatitude) {
    const params = new FormData()
    files.forEach(f => params.append('files', f))
    if (businessModule) params.append('businessModule', businessModule)
    params.append('address', address)
    params.append('longitudeAndLatitude', longitudeAndLatitude)
    return new Promise((r, j) => {
      this.upload(Setting.apiBaseURL + 'multi-upload', params).then(r).catch(err => {
        Toast.fail('文件上传失败')
        j(err)
      });
    })
  }
}
export default request
